import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import { Fragment } from "react";
import { useBoard } from "../../../providers/BoardDetailProvider";
import { CheckSpFlag } from "../../../hooks/CheckSpFlag";

const BoardBodyContent = () => {
  const {
    state: { boardDetailData },
  } = useBoard();

  const { title = "", content = "", image_urls = [] } = boardDetailData ?? {};
  const imageUrlsLength = image_urls.length;
  const isSP = CheckSpFlag();

  return (
    <Fragment>
      <div
        className={STBoardDetail.boardBodyTitle}
        style={{
          marginTop: imageUrlsLength > 1 && isSP ? 20 : 0,
        }}
      >
        {title}
      </div>
      <div className={STBoardDetail.boardBodyDescription}>{content}</div>
    </Fragment>
  );
};

export default BoardBodyContent;
